export const CLASS_NAME = 'cst-bar-chart'
